import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
